// extracted by mini-css-extract-plugin
export default {"create_item":"authorsAdmin_create_item__4sMSN","image":"authorsAdmin_image__j8lcW","image_item":"authorsAdmin_image_item__4qFAy","delete_item":"authorsAdmin_delete_item__80Wug"};